import React, { useContext } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { useAggregate } from 'hooks';
import { Config } from 'configs';
import { Loader } from 'components/indicators/loader';
import { CompanyOnboardingForm } from './partials/onboardingForm';

export const CompanyOnboarding = () => {
  const { state: auth } = useContext(AuthContext);

  const [, onboarding, loading] = useAggregate({
    collectionName: Config.DATA.COLLECTIONS.WEB_USERS,
    aggregateId: '9c5aaf71-11a6-47ff-b637-ebadd9008b64',
    secretKey: auth.token,
    filter: { userId: auth.company?._id },
    aggregateIdV2: 'AdminGetOnboardingDetails',
    companyIdForV2: auth.company?.company,
  });

  if (loading) {
    return <Loader />;
  }

  return <CompanyOnboardingForm itemData={onboarding && onboarding.length > 0 ? onboarding[0] : {}} />;
};
